export default __webpack_public_path__ + "static/banner-bottom-image-b-430183182c16896940b03216cc9e4233.png";